const { abstractResource } = require('./abstractResource')

const service = abstractResource('PROJECTS')

const Project = {
    ...service('projects'),
    get_form () {
        return {
            name: null,
            photo: null,
            advancement: 0,
            description: null,
            deadline: null,
            status: 'in_progress',
        }
    },

    get_status () {
        return [
            { value: 'in_progress', text: 'En cours' },
            { value: 'ended', text: 'Terminer' },
            { value: 'canceled', text: 'Annuler' },
        ]
    },
}

const Step = {
    ...service('steps'),
    get_form () {
        return {
            project: null,
            order: 0,
            name: null,
            label: null,
        }
    },
}

const Task = {
    ...service('tasks'),
    get_form () {
        return {
            title: null,
            description: null,
            step: null,
            deadline: null,
            labels: [],
            assigned_users: [],
            to_do_list: null,
            priority: 'weak',
            topics: [],
            late_management: false,
            at_risk: 0,
            wrong_way: 0
        }
    },

    get_priority_choices () {
        return [
            { text: 'Priorité faible', value: 'weak' },
            { text: 'Priorité moyenne', value: 'medium' },
            { text: 'Priorité forte', value: 'strong' },
        ]
    },
}

const LabelProject = {
    ...service('tasks'),

    get_form () {
        return {
            name: null,
            color: Math.floor(Math.random() * 16777215).toString(16),
        }
    },
}

const ToDoList = {
    ...service('tasks'),

    get_form () {
        return {
            name: null,
        }
    },
}

const ToDoStates = {
    ...service('tasks'),

    get_form () {
        return {
            assigned_users: [],
            is_done: false,
            name: null,
            deadline: null,
            to_do_list: null,
        }
    },
}

const Comment = {
    ...service('tasks'),

    get_form () {
        return {
            assigned_users: [],
            message: null,
            task: null,
        }
    },
}

const Report = {
    ...service('reports'),
}

module.exports = {
    Comment,
    LabelProject,
    Project,
    Step,
    Task,
    ToDoList,
    ToDoStates,
    Report
}
